const openHelpDeskSupport = (): void => {
    const btn = document.getElementById('hde-chat-init-btn-1');

    if (btn) {
        btn.click();
    }
};

export default openHelpDeskSupport;
